import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetFraudTypeHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { FRAUD_TYPE } from '../../../../../routes/paths';

export const useFraudTypeDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idFraudType } = useParams();
    const [loading, setLoading] = useState(false);
    const [fraudType, setFraudType] = useState<Param>();
    const [fraudTypeHistorical, setFraudTypeHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idFraudType)) {
            setLoading(true);
            asyncGetParam(idFraudType)
                .then((fraudType: any) => {
                    if (!fraudType || !fraudType.items) navigate(FRAUD_TYPE);
                    setFraudType(fraudType?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFraudType]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetFraudTypeHistorical(idFraudType)
                .then((resp) => {
                    if (resp) setFraudTypeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        fraudType,
        fraudTypeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
